<div class="card mt-6">
  <div class="flex justify-between items-center mb-4">
    <h3 class="text-lg font-semibold">
      {{ 'project.steps.rfd.invitationList.scheduleTitle' | transloco }}
    </h3>
  </div>

  @if (loading()) {
    <app-loading />
  } @else {
    <p-table
      [value]="rows()"
      [responsiveLayout]="'scroll'"
      class="p-datatable-striped"
      data-testid="rfd-schedule-table"
    >
      <ng-template #header>
        <tr>
          <th scope="col" style="width: 20%">
            {{ 'project.steps.invitationList.provider' | transloco }}
          </th>
          <th scope="col" style="width: 20%">
            {{ 'project.steps.invitationList.tool' | transloco }}
          </th>
          <th scope="col" style="width: 15%">
            {{ 'project.steps.rfd.invitationList.rfdDatetime' | transloco }}
          </th>
          <th scope="col" style="width: 15%">
            {{ 'project.steps.rfd.invitationList.place' | transloco }}
          </th>
          <th scope="col" style="width: 15%">
            {{ 'common.status' | transloco }}
          </th>
          <th scope="col" style="width: 15%"></th>
        </tr>
      </ng-template>

      <ng-template #body let-row>
        <tr>
          <td>{{ row.providerName }}</td>
          <td>{{ row.hrToolDisplayName }}</td>
          <td>
            <div class="flex align-items-center gap-2">
              <p-datePicker
                [ngModel]="getPendingDatetime(row)"
                (ngModelChange)="onDatetimeChange(row, $event)"
                (onClose)="applyDatetimeOnPickerClose(row)"
                [showTime]="true"
                hourFormat="24"
                dateFormat="dd/mm/yy"
                [hideOnDateTimeSelect]="false"
                appendTo="body"
                [disabled]="isRowInputDisabled(row)"
                [placeholder]="
                  'project.steps.rfd.invitationList.rfdDatetimePlaceholder' | transloco
                "
              >
                <ng-template #footer>
                  <div class="flex justify-end">
                    <p-button
                      size="small"
                      severity="secondary"
                      [label]="'common.select' | transloco"
                      (onClick)="applyDatetimeOnSelectButton(row)"
                      [disabled]="isApplyDisabled(row)"
                    ></p-button>
                  </div>
                </ng-template>
              </p-datePicker>
            </div>
          </td>
          <td>
            <p-select
              [options]="placeOptions()"
              [ngModel]="row.rfdPlace"
              (ngModelChange)="onPlaceChange(row, $event)"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [placeholder]="'project.steps.rfd.invitationList.placePlaceholder' | transloco"
              [disabled]="isRowInputDisabled(row)"
              [style]="{width: '140px'}"
            ></p-select>
          </td>
          <td>
            <p-select
              [options]="appointmentStatusOptions()"
              [ngModel]="row.rfdAppointmentStatus"
              (ngModelChange)="onAppointmentStatusChange(row, $event)"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [placeholder]="'common.select' | transloco"
              [disabled]="isRowInputDisabled(row)"
              [style]="{width: '160px'}"
            ></p-select>
          </td>
          <td class="text-right">
            <p-button
              size="small"
              severity="secondary"
              icon="pi pi-user"
              [label]="'project.steps.rfd.invitationList.contact' | transloco"
              (onClick)="openContact(row)"
            ></p-button>
          </td>
        </tr>
      </ng-template>

      <ng-template #emptymessage>
        <tr>
          <td colspan="6">
            <app-no-data label="project.steps.rfd.invitationList.noAcceptedTools" />
          </td>
        </tr>
      </ng-template>
    </p-table>

    @if (hasChanges()) {
      <div class="flex justify-end mt-4">
        <p-button
          type="button"
          (onClick)="onSave()"
          [label]="'common.save' | transloco"
          [disabled]="stepLocked()"
          appConfirmStepLeaveDirective
        ></p-button>
      </div>
    }

    <app-rfd-schedule-calendar [appointments]="calendarAppointments()" />
  }

  <app-provider-contact-modal
    [visible]="contactModalVisible()"
    [loading]="contactModalLoading()"
    [providerName]="contactModalProviderName()"
    [contactPerson]="contactModalContact()"
    (visibleChange)="contactModalVisible.set($event)"
  />
</div>
